import { Domains } from '../../constants';
import { ApiMasterDataQueryFilterItem } from '../../types';
import { BaseAuthedTracker } from './baseTracker';

const FILTER_APPLIED_EVENT = '[Filter] Applied';
const FILTER_RESET_EVENT = '[Filter] Reset';
const FILTER_OPENED_EVENT = '[Filter] Opened';
const FILTER_CLOSED_EVENT = '[Filter] Closed';

export class FilterTracker {
  constructor(
    readonly tracker: BaseAuthedTracker,
    readonly domain: Domains
  ) {}

  public trackFilterApply = (filter: ApiMasterDataQueryFilterItem) => {
    this.tracker.track(FILTER_APPLIED_EVENT, this.domain, {
      filter,
    });
  };

  /**
   * Call this when user reset ALL filter
   */
  public trackFilterReset = (actionData: any = {}) => {
    this.tracker.track(FILTER_RESET_EVENT, this.domain, { ...actionData });
  };

  /**
   * Call this when user open FilterTray
   */
  public trackFilterOpen = (actionData: any = {}) => {
    this.tracker.track(FILTER_OPENED_EVENT, this.domain, { ...actionData });
  };

  /**
   * Call this when user hide FilterTray
   */
  public trackFilterClose = (actionData: any = {}) => {
    this.tracker.track(FILTER_CLOSED_EVENT, this.domain, { ...actionData });
  };
}
